import type React from "react";

import { EnrichmentContactsCsvContainer } from "app/pages/sales-intelligence/modules/enrichment/containers/EnrichmentCsvContainer/EnrichmentContactsCsvContainer";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { ErrorView } from "app/pages/sales-intelligence/modules/enrichment/components/enrichment-csv/Error";
import type { ContactsEnrichmentModalStage } from "app/pages/sales-intelligence/modules/enrichment/components/type";
import UploadCSVEnrichmentContainer from "app/pages/sales-intelligence/modules/enrichment/containers/UploadCSVEnrichmentContainer/UploadCSVEnrichmentContainer";
import type { PostContactsCsvProps } from "app/pages/sales-intelligence/modules/enrichment/store/type";
import type { ContactsHeaderSelection } from "app/pages/sales-intelligence/sub-modules/management/components/types";

type ModalContentProps = {
    selectedHeaders: ContactsHeaderSelection;
    fileName: string;
    modalStage: ContactsEnrichmentModalStage;
    onConfirm: (props: PostContactsCsvProps) => void;
    onReplace: () => void;
    onClose: () => void;
    onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    setSelectedHeaders: (value: ContactsHeaderSelection) => void;
};

export const ContactsModalContent = ({
    onConfirm,
    onReplace,
    setSelectedHeaders,
    onFileChange,
    onClose,
    selectedHeaders,
    fileName,
    modalStage,
}: ModalContentProps) => {
    const modalContent = {
        upload: (
            <UploadCSVEnrichmentContainer
                onClose={onClose}
                onFileChange={onFileChange}
                type="contact"
            />
        ),
        enrichment: (
            <EnrichmentContactsCsvContainer
                setSelectedHeaders={setSelectedHeaders}
                onClose={onClose}
                onConfirm={onConfirm}
                onReplace={onReplace}
                selectedHeaders={selectedHeaders}
                fileName={fileName}
            />
        ),
    };

    return (
        <ErrorBoundaryWithLogging FallbackComponent={() => <ErrorView onClose={onClose} />}>
            {modalContent[modalStage]}
        </ErrorBoundaryWithLogging>
    );
};
